import {UserType} from "../constants/User.type";
import {LicenseDto} from "./License.dto";

export interface UserDto {
    seq: number;
    name: string;
    email: string;
    type: UserType;
    companyName: string;
    businessNumber: string;
    companyType: string,
    licenses: LicenseDto[]
    thumbnail: string;
}

export const InitialUser: UserDto = {
    seq: 0,
    name: "",
    email: "",
    type: UserType.INDIVIDUAL,
    companyName: "",
    businessNumber: "",
    companyType: "",
    licenses: [],
    thumbnail: ""
}